import Grade from '@/components/courseCenter/public/grade/Grade.vue';
import api from '../../../common/libs/api.js';
import CourseBanner from '@/components/courseCenter/public/banner/Banner.vue';
import {mapState} from 'vuex';
import Manage from '@/components/courseCenter/one/public/Manage.vue';
import localforage from 'localforage';
import vue from 'vue';
import InfiniteLoading from '@/components/courseCenter/public/vue-infinite-loading/components/InfiniteLoading';
import _ from 'lodash';
import CityCodeData from '@/common/libs/CityCodeData';
import utils from '../../../common/libs/utils.js';

export default{
  name: 'One',
  components: {
    Grade,
    CourseBanner,
    Manage,
    InfiniteLoading
  },
  computed: mapState({
    city: state => state.home.city,
    grade: state => state.course.grade,
    location: state => state.home.location,
    network: state => state.home.network,
    coursesList: state => state.faceToface.coursesList,
    bannerList: state => state.faceToface.bannerList,
    consultantInfo: state => state.faceToface.consultantInfo,
    category: state => state.faceToface.conditions.category,
    first: state => state.faceToface.first,
    isTouchEnd: state => state.faceToface.isTouchEnd,
    noResult: state => state.faceToface.noResult
  }),
  metaData({store, route}){
    var city = CityCodeData.getCityByShort(route.params.city);

    store.dispatch("setMeta", {
      title: `面授1对1选课中心_中小学在线选课_${ city.city_name  }${city.brand||'学而思爱智康'}`,
      description: `${city.city_name +(city.brand||'学而思爱智康')}面授1对1选课中心提供小学、初中、高中一对一辅导，学而思爱智康课程包括语文、数学、英语、物理、化学等科目的一对一辅导课、8人班小组课、精品课、在线课,选课热线：400-810-2680`,
      keywords: `${city.city_name +(city.brand||'学而思爱智康')}面授1对1,${city.city_name}爱智康一对一辅导,面授1对1选课中心,${city.city_name}${city.brand||'学而思爱智康'}在线选课`
    });
  },
  asyncData({store, route}){
    store.commit('resetOne');

    let params = _.clone(store.state.faceToface.conditions);
    let city = CityCodeData.getCityByShort(route.params.city);
    let location = store.state.home.location;
    console.log('params:', params);
    console.log('route.params:', route.params);
    console.log('当前城市：', city);
    params.city = (city&&city.city_code)||'010';
    params.category = '10001';
    params.type = route.query.type || '';
    params.grade = route.query.grade || store.state.course.grade.grid || '9';
    params.pn = 1;
    params.rn = 10;
    params.term = route.query.term || '';
    params.subject = route.query.subject || '';
    params.school_id = route.query.school_id || '';
    params.lat = location.lat;
    params.lng = location.lng;
    console.log('initFaceToFace conditions:', params);
    return store.dispatch('initFaceToFace', {conditions: params});
  },
  data(){
    return {
      phone: '',
      tip: false,           //提示窗
      point: false,          //电话咨询窗
      tipTimer: '',
      pointTimer: '',
      chosedGrade: '',
      conditWord: '按距你最近的学习中心排序'
    }
  },
  watch: {
    $route(to, from) {
      this.$store.commit('resetOne');

      let params = _.clone(this.$store.state.faceToface.conditions);
      let city = CityCodeData.getCityByShort(this.$route.params.city);
      let location = this.$store.state.home.location;
      let route = this.$route;

      params.city = (city&&city.city_code)||'010';;
      params.category = '10001';
      params.type = route.query.type || '';
      params.grade = route.query.grade || this.$store.state.course.grade.grid || '9';
      params.pn = 1;
      params.rn = 10;
      params.term = route.query.term || '';
      params.subject = route.query.subject || '';
      params.school_id = route.query.school_id || '';
      params.lat = location.lat;
      params.lng = location.lng;

      this.$store.dispatch('initFaceToFace', {conditions: params});
    },
    grade: {
      handler: function(newVal, oldVal){
        //grade发生变化时，根据grade改变banner
        this.getBanners(newVal.grid);

        let params = _.clone(this.$store.state.faceToface.conditions);
        params.pn = 1;
        params.grade = newVal.grid || oldVal.grid;
        //this.$store.commit('setCourseList', []);
        this.$store.dispatch('getFaceToFaceList', {conditions: params, isFilter: true});
      }
    },
    network: {
      handler: function(newVal, oldVal){
        if (!newVal){
          this.noResult = true;
          this.first = true;
        }
        this.$store.commit('changeNetWork', true);
      },
      deep: true
    }
  },
  methods: {
    infiniteHandler($state){
      if (this.isTouchEnd){
        return;
      }
      var params = _.clone(this.$store.state.faceToface.conditions);
      params.pn = params.pn+1;
      this.$store.dispatch('getFaceToFaceList', {
        conditions: params,
        $state: $state
      });
    },
    filter(){
      //显示loading
      this.$store.commit('isShowLoading', true);

      this.$router.push({name: 'conditions', query: {
        name: 'faceToface',
        category: this.category,
        teaching_mode: '1001'
      }});
    },
    closePoint(){
      this.point = false;
    },
    seeQq(){
      this.$router.push({name: 'qq'});
    },
    clearTimer(){
      clearTimeout(this.tipTimer);
      clearTimeout(this.pointTimer);
      this.tip = false;
      this.point = false;
    },
    getBanners(val){
      let city = CityCodeData.getCityByShort(this.$route.params.city);
      let obj = {
        city: city.city_code,
        category: '10001',
        grade: val || this.chosedGrade
      }
      this.$store.dispatch('getFaceToFaceBanners', obj);
    },
    timer(){
      //定时显示悬浮窗的timer
      let vm = this;

      localforage.getItem('izk-is-first-faceToFace').then(function(value){
        if (!value){
          vm.tip = true;
          vm.tipTimer = setTimeout(function(){
            vm.tip = false;
            vm.point = true;
            clearTimeout(vm.tipTimer);
            vm.pointTimer = setTimeout(function(){
              vm.point = false;
              clearTimeout(vm.pointTimer);
            }, 3000)
          }, 2000);

          localforage.setItem('izk-is-first-faceToFace', 1);
        }
      });
      localforage.setItem('izk-is-first-faceToFace', 1);
    },

    phoneCall(){
      utils.bury('yd_izhikang_studyconsultant_tel_consult', {});

      let tel = `tel:${  this.consultantInfo.consultant_phone || '4008102680'}`;
      window.location.href = tel;
    },
    getWord(){
      let route = this.$route.query;
      this.conditWord = '';
      if (route.subjectMsg){
        this.conditWord += `${route.subjectMsg  } / `;
      }
      if (route.typeMsg){
        this.conditWord += `${route.typeMsg  } / `;
      }
      if (route.termMsg){
        this.conditWord += `${route.termMsg  } / `;
      }
      if (route.gradeMsg){
        this.conditWord += `${route.gradeMsg  } / `;
      }
      if (route.school_name){
        this.conditWord += route.school_name;
      }
    }
  },
  mounted(){ 
    //隐藏loading
    this.$store.commit('isShowLoading', false);

    this.$store.commit('isShowHeader', {isShowHeader: true});
    this.$store.commit('isShowFooter', {isShowFooter: true});
    if (this.$route.query.gradeMsg){
      this.getWord();
    }

    let vm = this;
    vue.prototype.clearFaceTime = this.clearTimer;

    localforage.getItem('izk-grade-list-grid').then(function(grade){
      //如果已经有了先根据已有的显示，用户再改变之后再根据用户的改变而展示
      //根据url中的城市进行推荐，城市变了之后，域名会变，页面会刷新，所以不用watch city是否改变
      if (grade){
        vm.chosedGrade = grade.grid;
        vm.getBanners();
      }
    })

    let stater = this.$store.state;
    let obj = {
      'page_name': '选课中心（面授1对1）',
      'locate_city': this.city.city_name,
      'user_grade': stater.course.grade.name || '三年级'
    }
    utils.bury('yd_izhikang_page_browse', obj);
  }
}

















// WEBPACK FOOTER //
// ./src/components/courseCenter/one/One.js